const createCount = (input, maxLength) => {
  const count = document.createElement('SPAN')
  count.dataset.maxLengthCount = ''
  count.textContent = `${input.value.length} / ${maxLength}`
  return count
}
document.querySelectorAll('.sea-textarea').forEach((root) => {
  const input = root.querySelector('textarea')
  if (input) {
    const maxLength = +input.dataset.maxLength
    let count = null
    if (maxLength && maxLength > 0) {
      count = createCount(input, maxLength)
      root.appendChild(count)
    }
    if (count) {
      input.addEventListener('keypress', (event) => {
        if (input.value.length >= maxLength) {
          event.preventDefault()
        }
      })
      input.addEventListener('input', () => {
        if (input.value.length >= maxLength) {
          input.value = input.value.substring(0, maxLength)
        }

        count.textContent = `${input.value.length} / ${maxLength}`
      })
    }
  }
})
